const getUUID = (): string => {
    if (window.crypto && crypto.randomUUID) {
        return crypto.randomUUID();
    } else {
        return Math.random().toString(32).slice(2);
    }
};

export const getCdIdempotency = (): string => {
    const uuid = getUUID();
    const timestamp = new Date().getTime();

    return btoa(`${uuid}__${timestamp}`);
};
